import { ArrowSquareDown } from '../../icons';
import { Dropdown } from '../Dropdown/Dropdown';

type Props = {
  ariaLabel?: string;
  className?: string;
  items: NonNullable<Parameters<typeof Dropdown>[0]['menu']>['items'];
  trigger?: Parameters<typeof Dropdown>[0]['trigger'];
};

export function ExportMenu({
  ariaLabel,
  className = 'secondary',
  items,
  trigger,
}: Props) {
  return (
    <div className="export-btn print-hidden">
      <Dropdown
        ariaLabel={ariaLabel}
        className={className}
        label="Export"
        menu={{ items }}
        icon={<ArrowSquareDown />}
        overlayClassName="export-dropdown"
        trigger={trigger}
      />
    </div>
  );
}
